import { shared, SlideScanItem } from '@tig-dpqa-cloud/contract-backend-common';
import { z } from 'zod';

export const VerifyStatus = shared.SlideScanVerifiedStatus.describe(
  'The current status of the slide scan to store in the back-end.',
);
export type VerifyStatusType = z.infer<typeof VerifyStatus>;

const VerifyRequestBase = z.object({
  isPhiDetected: z.boolean().prefault(true),
  detectedIssues: z.array(shared.SlideScanDetectedIssue.omit({ slideScanId: true })),
  comment: z.string().optional(),
});

export const VerifyRequest = z.discriminatedUnion('generalQcStatus', [
  VerifyRequestBase.extend({
    status: z.literal(VerifyStatus.enum.CONFIRMED),
    generalQcStatus: z.literal(shared.SlideScanGeneralQcStatus.enum.GOOD),
  }),
  VerifyRequestBase.extend({
    status: VerifyStatus,
    generalQcStatus: z.literal(shared.SlideScanGeneralQcStatus.enum.BAD),
  }),
]);

export type VerifyRequestType = z.infer<typeof VerifyRequest>;

export const VerifySlideScanResponse = z.object({
  data: SlideScanItem,
});

export type VerifySlideScanResponseType = z.infer<typeof VerifySlideScanResponse>;

export const VerifyMultipleRequest = z.object({
  slideScanIds: z.array(shared.SlideScanId),
  status: z.literal(VerifyStatus.enum.CONFIRMED),
  generalQcStatus: z.literal(shared.SlideScanGeneralQcStatus.enum.GOOD),
});

export type VerifyMultipleRequestType = z.infer<typeof VerifyMultipleRequest>;

export const VerifyRequestQueryParams = z.object({ reverify: z.string().transform((value) => value === 'true').optional() });
export type VerifyRequestQueryParamsType = z.infer<typeof VerifyRequestQueryParams>;
